import { render } from "./BancaOre.vue?vue&type=template&id=8566b8aa&scoped=true&ts=true"
import script from "./BancaOre.vue?vue&type=script&lang=ts"
export * from "./BancaOre.vue?vue&type=script&lang=ts"

import "./BancaOre.vue?vue&type=style&index=0&id=8566b8aa&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_energy-saving_1764367324033741919/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8566b8aa"]])

export default __exports__